import React, { useState } from 'react'

export const Contact = (props) => {
  const [copiedEmail, setCopiedEmail] = useState(false)
  const [copiedPhone, setCopiedPhone] = useState(false)
  
  const contactEmail = props.data ? props.data.email : 'info@ucept.online'
  const contactPhone = props.data ? props.data.phone : '+1 716-XXX-XXXX'
  const contactAddress = props.data ? props.data.address : '3101 Govalle Ave, Austin, TX 78702'

  const copyEmail = () => {
    navigator.clipboard.writeText(contactEmail).then(() => {
      setCopiedEmail(true)
      setTimeout(() => setCopiedEmail(false), 2000)
    })
  }

  const copyPhone = () => {
    navigator.clipboard.writeText(contactPhone).then(() => {
      setCopiedPhone(true)
      setTimeout(() => setCopiedPhone(false), 2000)
    })
  }

  const handleEmailUs = () => {
    window.location.href = `mailto:${contactEmail}`
  }

  const handleCall = () => {
    window.location.href = `tel:${contactPhone.replace(/[^0-9+]/g, '')}`
  }

  return (
    <div>
      <div id='contact'>
        <div className='container'>
          <div className='col-md-12 text-center' style={{ marginBottom: '50px' }}>
            <h2>Get In Touch</h2>
            <p style={{ maxWidth: '600px', margin: '0 auto', fontSize: '18px' }}>
              We'd love to hear from you. Reach out using any of the methods below.
            </p>
          </div>
          
          <div className='col-md-12'>
            <div style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              flexWrap: 'wrap',
              gap: '20px',
              marginBottom: '40px'
            }}>
              {/* Email Card */}
              <div 
                onClick={copyEmail}
                style={{ 
                  backgroundColor: 'rgba(255,255,255,0.15)',
                  borderRadius: '12px',
                  padding: '25px 40px',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  minWidth: '280px',
                  textAlign: 'center'
                }}
                onMouseOver={(e) => e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.25)'}
                onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.15)'}
              >
                <i className='fa fa-envelope' style={{ fontSize: '28px', marginBottom: '15px', display: 'block' }}></i>
                <p style={{ fontSize: '13px', margin: '0 0 8px 0', opacity: '0.8', textTransform: 'uppercase', letterSpacing: '1px' }}>Email</p>
                <p style={{ fontSize: '18px', fontWeight: '600', margin: '0 0 8px 0' }}>{contactEmail}</p>
                {copiedEmail ? (
                  <p style={{ fontSize: '12px', color: '#90EE90', margin: 0 }}>
                    <i className='fa fa-check' style={{ marginRight: '5px' }}></i>Copied!
                  </p>
                ) : (
                  <p style={{ fontSize: '12px', opacity: '0.6', margin: 0 }}>Click to copy</p>
                )}
              </div>

              {/* Phone Card */}
              <div 
                onClick={copyPhone}
                style={{ 
                  backgroundColor: 'rgba(255,255,255,0.15)',
                  borderRadius: '12px',
                  padding: '25px 40px',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  minWidth: '280px',
                  textAlign: 'center'
                }}
                onMouseOver={(e) => e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.25)'}
                onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.15)'}
              >
                <i className='fa fa-phone' style={{ fontSize: '28px', marginBottom: '15px', display: 'block' }}></i>
                <p style={{ fontSize: '13px', margin: '0 0 8px 0', opacity: '0.8', textTransform: 'uppercase', letterSpacing: '1px' }}>Phone</p>
                <p style={{ fontSize: '18px', fontWeight: '600', margin: '0 0 8px 0' }}>{contactPhone}</p>
                {copiedPhone ? (
                  <p style={{ fontSize: '12px', color: '#90EE90', margin: 0 }}>
                    <i className='fa fa-check' style={{ marginRight: '5px' }}></i>Copied!
                  </p>
                ) : (
                  <p style={{ fontSize: '12px', opacity: '0.6', margin: 0 }}>Click to copy</p>
                )}
              </div>

              {/* Address Card */}
              <div 
                style={{ 
                  backgroundColor: 'rgba(255,255,255,0.15)',
                  borderRadius: '12px',
                  padding: '25px 40px',
                  minWidth: '280px',
                  textAlign: 'center'
                }}
              >
                <i className='fa fa-map-marker' style={{ fontSize: '28px', marginBottom: '15px', display: 'block' }}></i>
                <p style={{ fontSize: '13px', margin: '0 0 8px 0', opacity: '0.8', textTransform: 'uppercase', letterSpacing: '1px' }}>Location</p>
                <p style={{ fontSize: '16px', fontWeight: '600', margin: 0, lineHeight: '1.4' }}>{contactAddress}</p>
              </div>
            </div>
          </div>

          <div className='col-md-12 text-center' style={{ marginBottom: '40px' }}>
            <button 
              onClick={handleEmailUs} 
              className='btn btn-custom btn-lg'
              style={{ 
                backgroundColor: '#fff', 
                color: '#6372ff', 
                border: 'none',
                marginRight: '15px',
                padding: '14px 40px'
              }}
            >
              <i className='fa fa-paper-plane' style={{ marginRight: '10px' }}></i>
              Send Email
            </button>
            <button 
              onClick={handleCall} 
              className='btn btn-custom btn-lg'
              style={{ 
                backgroundColor: 'transparent', 
                color: '#fff', 
                border: '2px solid #fff',
                padding: '12px 40px'
              }}
            >
              <i className='fa fa-phone' style={{ marginRight: '10px' }}></i>
              Call Us
            </button>
          </div>

          <div className='col-md-12'>
            <div className='row'>
              <div className='social'>
                <ul>
                  <li>
                    <a href={props.data ? props.data.instagram : '/'}>
                      <i className='fa fa-instagram'></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.twitter : '/'}>
                      <i className='fa fa-twitter'></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
